import React, { useEffect } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import CalendarModal from "../CalendarSale/CalendarModal/CalendarModal";
import { MdArrowBackIosNew } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { setExerciseName, setExerciseZoneId } from "../../store/pseudoModal/pseudoModalsActions";
import EAButton from "../shared/Buttons/EAButton";
import { CALENDAR_SALE } from "../../routes";
import { goToPreviousPage } from "../../../utils/goToPreviousPage";
import EAChip from "../shared/Chip/EAChip";

const ModalWindow: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const exerciseNames = useSelector((state: State) => state.pseudoModals.exerciseName);
  const exercisesZoneId = useSelector((state: State) => state.pseudoModals.exerciseZoneId);

  const getQueryParam = (key: string): string => {
    const query = location.search.startsWith("?") ? location.search.slice(1) : location.search;
    const regex = new RegExp(`(?:^|&)${key}=([^&]*)`);
    const match = query.match(regex);
    return match ? decodeURIComponent(match[1]) : "";
  };

  const exerciseIdsParam = getQueryParam("exerciseIds");
  const exerciseNameParam = getQueryParam("exerciseName");
  const exerciseLocationParam = getQueryParam("location");

  useEffect(() => {
    if (exerciseNameParam && exerciseIdsParam) {
      dispatch(setExerciseName(exerciseNameParam));
      dispatch(setExerciseZoneId(Number(exerciseIdsParam)));
    }
    //eslint-disable-next-line
  }, [exerciseIdsParam, exerciseNameParam]);

  return (
    <React.Fragment>
      <div className="modal-window-header">
        <EAButton
          title={t("wroc")}
          onClick={() => goToPreviousPage(navigate, CALENDAR_SALE)}
          startIcon={<MdArrowBackIosNew />}
          variant="text"
        />
        <div className="modal-window-header__content">
          <h1 className="no-margins">
            {t("kup_bilet")}:<b>{exerciseNames}</b>
          </h1>
          {exerciseLocationParam && (
            <EAChip
              label={exerciseLocationParam}
              icon={<IoLocationOutline />}
              variant="primary"
              className="modal-window-header__location-chip"
            />
          )}
        </div>
      </div>
      <div>
        {exerciseNames.length > 2 && exercisesZoneId && (
          <CalendarModal exerciseName={exerciseNames} zone={exercisesZoneId} />
        )}
      </div>
    </React.Fragment>
  );
};

export default ModalWindow;
